import { render, staticRenderFns } from "./ExceedingVehicleSpeedLimit.vue?vue&type=template&id=318982c8&"
import script from "./ExceedingVehicleSpeedLimit.vue?vue&type=script&lang=js&"
export * from "./ExceedingVehicleSpeedLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports